const sumOfArray = (items = []) =>
  items.reduce((total, item) => total + (Number(item) || 0), 0);

const calculateWidth = (totalWidth, remainingElements) => {
  const remaining = Math.max(remainingElements || 0, 1);
  const width = (100 - (Number(totalWidth) || 0)) / remaining;
  return `${Math.max(width, 0)}%`;
};

const combineStyles = (...styles) => styles.filter(Boolean);

const PDFRenderUtils = {
  sumOfArray,
  calculateWidth,
  combineStyles,
};

export default PDFRenderUtils;
